export class RateTableFileReadException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RateTableFileReadException';
  }
}
